import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { MenuItem, useMediaQuery, useTheme } from '@mui/material';
import { useChangePassword } from 'api/profile/useChangePassword/useChangePassword';
import { SettingsDropdownMenu } from 'components/shared/SettingsDropdownMenu/SettingsDropdownMenu';
import { useAtom } from 'jotai';
import { useState } from 'react';
import { useCookies } from 'react-cookie';
import { user } from 'store/public/user';
import { removeUser } from 'utils/js/user';
import { removeUserPermissionsFromLocal } from 'utils/js/userPermissions';

import UserChangePasswordModal from './UserChangePasswordModal';

export const UserSettingsDropdown = props => {
  const theme = useTheme();
  const isBelowDesktop = useMediaQuery(theme.breakpoints.down('lg'));
  const [_, setCookie, removeCookie] = useCookies(['token']);

  const { changePasswordRequest } = useChangePassword();

  const [userInfo, setUserState] = useAtom(user);
  const [activeModal, setActiveModal] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogOut = () => {
    setUserState(null);
    removeUser();
    removeUserPermissionsFromLocal();
    removeCookie('token', {
      path: '/',
    });
  };

  const onChangePasswordHandle = ({ currentPassword, newPassword }) => {
    changePasswordRequest({
      currentPassword,
      newPassword,
      onSuccess: () => {
        setActiveModal(null);
      },
    });
  };

  const onChangePassword = () => {
    setActiveModal('changePassword');
  };

  return (
    <>
      <SettingsDropdownMenu
        title={`${userInfo?.name || ''} ${userInfo?.lastname || ''}`}
        type={
          props.transparent && isBelowDesktop
            ? 'transparent'
            : isBelowDesktop
            ? 'circlular'
            : 'square'
        }
        anchorEl={anchorEl}
        isOpen={isOpen}
        icon={
          <PersonOutlineOutlinedIcon
            {...(props.iconProps || {})}
            fontSize={props.size ?? 'medium'}
          />
        }
        size={props.size}
        onToggle={e => setAnchorEl(e.currentTarget)}
        handleClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <AccountCircleOutlinedIcon />
          پروفایل
        </MenuItem>
        <MenuItem onClick={onChangePassword}>
          <LockOutlinedIcon />
          تغییر رمز عبور
        </MenuItem>
        <MenuItem onClick={onLogOut}>
          <ExitToAppOutlinedIcon />
          خروج
        </MenuItem>
      </SettingsDropdownMenu>
      <UserChangePasswordModal
        open={activeModal === 'changePassword'}
        handleClose={() => setActiveModal(null)}
        onChangePassword={onChangePasswordHandle}
      />
    </>
  );
};
